import React, { useEffect, useState, Component } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Mail, Send, CheckCircle, User, MessageSquare } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ContactSupport() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Contact Support | IntelliEats';
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent(`IntelliEats Support: Message from ${name}`);
    const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`);
    window.location.href = `mailto:intellieats@gmail.com?subject=${subject}&body=${body}`;
    setSubmitted(true);
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="pt-32 pb-24 bg-white min-h-screen" data-id="element-1124" data-mp="132p9rp6uokuw">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1125" data-mp="3dwzg5v5wde9q">
        <header className="mb-12" data-id="element-1126" data-mp="3sl41l6wc43w7">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-brand-600 hover:text-brand-700 mb-8 transition-colors" data-id="element-1127" data-mp="3sldkybmvjcsx">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-1128" data-mp="2zw6hqzch5z1c" />
            Back to Home
          </Link>
          <div className="flex items-center gap-4 mb-6" data-id="element-1129" data-mp="2uxd85i0b6s6g">
            <div className="bg-blue-100 text-blue-600 p-3 rounded-2xl" data-id="element-1130" data-mp="2uywn95a8ax6n">
              <Mail className="w-8 h-8" data-id="element-1131" data-mp="39vnnthvn2exu" />
            </div>
            <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight" data-id="element-1132" data-mp="34vj65oizve61">
              Contact Support
            </h1>
          </div>
          <p className="text-lg text-slate-600" data-id="element-1133" data-mp="p32b1gj384gp">
            Have a question, feedback, or need help? We'd love to hear from you.
            Fill out the form below and we'll get back to you as soon as
            possible.
          </p>
        </header>

        {submitted ? <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="text-center py-16" data-id="element-1134" data-mp="w6sdpsnddl69">
            <div className="bg-brand-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1135" data-mp="163ew8as84054">
              <CheckCircle className="w-10 h-10 text-brand-600" data-id="element-1136" data-mp="dh3peie0x2zv" />
            </div>
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-1137" data-mp="der6a1wj4ml8">
              Your email client should open shortly!
            </h2>
            <p className="text-slate-600 mb-8 max-w-md mx-auto" data-id="element-1138" data-mp="n75bj4mtgbc5">
              Please send the pre-filled email to complete your message. If your
              email client didn't open, you can email us directly at{' '}
              <a href="mailto:intellieats@gmail.com" className="text-brand-600 font-medium hover:text-brand-700" data-id="element-1139" data-mp="3qup60ej5l6w7">
                intellieats@gmail.com
              </a>
            </p>
            <button onClick={() => {
          setSubmitted(false);
          setName('');
          setEmail('');
          setMessage('');
        }} className="px-6 py-3 bg-brand-600 text-white font-semibold rounded-xl hover:bg-brand-700 transition-colors" data-id="element-1140" data-mp="23x62pstc9v9c">
              Send Another Message
            </button>
          </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1141" data-mp="1g9pofu2ws11e">
            <div data-id="element-1142" data-mp="1g9y0xkv4d4c2">
              <label htmlFor="name" className="flex items-center gap-2 text-sm font-semibold text-slate-900 mb-2" data-id="element-1143" data-mp="1g7bslj0emkss">
                <User className="w-4 h-4 text-slate-500" data-id="element-1144" data-mp="16a76tkah0rci" />
                Your Name
              </label>
              <input type="text" id="name" value={name} onChange={e => setName(e.target.value)} required placeholder="Enter your full name" className="w-full px-4 py-3.5 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all" data-id="element-1145" data-mp="11cyy0ab7pznx" />
            </div>

            <div data-id="element-1146" data-mp="2imm3kp96d3ao">
              <label htmlFor="email" className="flex items-center gap-2 text-sm font-semibold text-slate-900 mb-2" data-id="element-1147" data-mp="2iq9ynsu9pxri">
                <Mail className="w-4 h-4 text-slate-500" data-id="element-1148" data-mp="28r2kx4jmg13v" />
                Email Address
              </label>
              <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="your@email.com" className="w-full px-4 py-3.5 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all" data-id="element-1149" data-mp="2dpvpg7gxkhrw" />
            </div>

            <div data-id="element-1150" data-mp="266d07jh3fsav">
              <label htmlFor="message" className="flex items-center gap-2 text-sm font-semibold text-slate-900 mb-2" data-id="element-1151" data-mp="266w6u41amu9l">
                <MessageSquare className="w-4 h-4 text-slate-500" data-id="element-1152" data-mp="2f5hugdlmgzh8" />
                Message
              </label>
              <textarea id="message" value={message} onChange={e => setMessage(e.target.value)} required rows={6} placeholder="Tell us how we can help you..." className="w-full px-4 py-3.5 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all resize-none" data-id="element-1153" data-mp="2b3wc4cqbjszn" />
            </div>

            <button type="submit" className="w-full flex items-center justify-center gap-2 px-6 py-4 bg-brand-600 text-white font-bold rounded-xl hover:bg-brand-700 transition-all shadow-lg shadow-brand-200/50 hover:shadow-brand-300/50 hover:-translate-y-0.5 duration-200" data-id="element-1154" data-mp="2pvnp8bpblbtk">
              <Send className="w-5 h-5" data-id="element-1155" data-mp="33qzlinj4jacl" />
              Send Message
            </button>

            <p className="text-center text-sm text-slate-500" data-id="element-1156" data-mp="38qcdtnsrl9mk">
              Your message will be sent to{' '}
              <span className="font-medium text-slate-700" data-id="element-1157" data-mp="3ii8g7b1vvlwl">
                intellieats@gmail.com
              </span>{' '}
              via your email client.
            </p>
          </form>}

        {/* Direct Contact Info */}
        <div className="mt-16 pt-12 border-t border-slate-100" data-id="element-1158" data-mp="3rjzkcbgrzkoc">
          <h3 className="text-lg font-bold text-slate-900 mb-6 text-center" data-id="element-1159" data-mp="cn3xynpvb9h">
            Other Ways to Reach Us
          </h3>
          <div className="grid sm:grid-cols-2 gap-6" data-id="element-1160" data-mp="agtznl2u1ffi">
            <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100 text-center" data-id="element-1161" data-mp="ae7hysm89jjk">
              <Mail className="w-6 h-6 text-brand-600 mx-auto mb-3" data-id="element-1162" data-mp="5jk3znouo7j8" />
              <h4 className="font-bold text-slate-900 mb-1" data-id="element-1163" data-mp="j5ue17lopj3">Email</h4>
              <a href="mailto:intellieats@gmail.com" className="text-brand-600 hover:text-brand-700 text-sm font-medium transition-colors" data-id="element-1164" data-mp="3smoxm8v0hb2i">
                intellieats@gmail.com
              </a>
            </div>
            <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100 text-center" data-id="element-1165" data-mp="oa1qhaj3a6w5">
              <MessageSquare className="w-6 h-6 text-brand-600 mx-auto mb-3" data-id="element-1166" data-mp="jf5mdc0kvt2o" />
              <h4 className="font-bold text-slate-900 mb-1" data-id="element-1167" data-mp="ff59vwx1hry9">
                App Store Review
              </h4>
              <p className="text-sm text-slate-600" data-id="element-1168" data-mp="1byuk30c8o2nl">
                Leave feedback on the App Store or Google Play
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}